<template>
  <div style="text-align: center">
    <v-icon v-if="params.data.hasImage == 1" color="green">mdi-check</v-icon>
    <v-icon v-else color="red">mdi-close</v-icon>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({}),
    beforeCreate() {},
    mounted() {},
    methods: {
      openActionMenu() {
        this.$store.dispatch("setAGGridActionMenuState", this.params.data);
      },
    },
  };
</script>